export class GuardarVehiculoSubcontratadoDTO {
    claseId?: number;
    vcContratista?: string;
    vcPlaca?: string;
    vcObservacionSubContratado?: string;
    tipoDocumentoId?: number;
    vcNumeroDocumento?: string;
    vcPrimerNombre?: string;
    vcSegundoNombre?: string;
    vcPrimerApellido?: string;
    vcSegundoApellido?: string;
    vcCelular?: string;
    vcCorreoPersonal?: string;
}